import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

// Components
import { Spin, Modal, Form, Row, Col, Alert, Input, InputNumber, Select, Icon, DatePicker } from 'antd';

// Selectors
import { getAddOrEditMeterModalIsLoading,
    getHomeDetailMetersData,
    getHomeDetailMetersAreLoading 
} from '../../../data/homes/selectors';
import {
    getMeterPurposes,
    getMeterPurposesIsLoading,
    getMeterTypes,
    getMeterTypesIsLoading,
    getModbusFlavors,
    getModbusFlavorsIsLoading    
} from '../../../data/meters/selectors';
import { isRoleAdministrator } from '../../../data/auth/selectors';

// Actions
import { onAddNewMeter, onEditMeter } from '../../../data/homes/actions';

// Constants
import { MODAL_SIZES } from '../../../constants/modal';
import moment from 'moment';
import { 
    fetchMeterPurposes, 
    onMeterPurposesList, 
    fetchMeterFlavors
     } from '../../../data/meters/actions';
import { fromJS } from 'immutable';

import { getDisplayLabelForMeterType } from '../../../utils';

class AddOrEditMeterModal extends PureComponent {
    fieldVisibilityDef = {
        modbusFlavor: { whiteList: true, list: [ 'SmartPi', 'iWattController', 'iWattControllerV3', 'IOTHub']},
        url : { whiteList: true, list: [ 'SolaxCloudApi']},
        macAddress: { whiteList: true, list: []},
        ipAddress : { whiteList: false, list: [ 'SolaxCloudApi', 'Difference']},
        meterA: { whiteList: true, list: [ 'Difference', ]},
        meterB: { whiteList: true, list: [ 'Difference', ]},
        meterSoc: { whiteList: true, list: [ 'Difference', ]},
        enphaseUser: { whiteList: true, list: [ 'EnphaseIqEnvoy', ]},
        enphasePassword: { whiteList: true, list: [ 'EnphaseIqEnvoy', ]},
        enphaseSerial: { whiteList: true, list: [ 'EnphaseIqEnvoy', ]},
        modbusId: { whiteList: true, list: ['HuaweiSun2000dongle', 'HuaweiDongleSensor', 'SolarEdgeInverter', 'SolarEdgeHybrid']},
        params: { whiteList: true, list: ['Solax', 'NeoomBeaam']}
    }

    componentDidMount() {
        const { recordToEdit, fetchMeterPurposes, fetchMeterFlavors } = this.props;
        if (recordToEdit) {
            fetchMeterPurposes(recordToEdit.meter);
        }
        fetchMeterFlavors(); 
    }

    handleSelectMeterType = (meterType) => {
        const { onMeterPurposesList, meterTypes } = this.props;
        for (let i=0; i < meterTypes.length; i +=1) {
            const mType = meterTypes[i];
            const l = mType.label;
            if (l === meterType) {
                const pu = mType.purposes;
                console.log(pu);
                onMeterPurposesList(pu);
            }
        }
    }

    handleSubmit = () => {
        const { form, onAfterSubmit } = this.props;
        let formHasErrors = false;

        form.validateFields((err, values) => {
            if (err) {
                formHasErrors = true;
                return;
            }            

            const { recordToEdit, msgs, params, onAddNewMeter, onEditMeter } = this.props;
            // for type == EnphaseIqEnvoy save credentials in third_party_access as JSon
            if (values && values.type && values.type === 'EnphaseIqEnvoy') {
                const x = { user: values.enphaseUser, password:values.enphasePassword, envoy_serial: values.enphaseSerial };
                const xJson = JSON.stringify(x);
                values.thirdPartyAccessUi = xJson;
            }
            if (!recordToEdit) {
                onAddNewMeter(values, params).catch(() => {
                    form.setFieldsValue({
                        hasError: msgs.homes.addHomeError
                    });
                });
            } else {
                onEditMeter(recordToEdit, values, params).catch(() => {
                    form.setFieldsValue({
                        hasError: msgs.homes.editHomeError
                    });
                });
            }
        });
        
        if(!formHasErrors){
            onAfterSubmit();
        }  
    };

    handleAlertClose = () => {
        const { form } = this.props;
        form.setFields({
            hasError: {
                value: undefined
            }
        });
    };

    getInitialPurpose = (recordToEdit)  => {
        const { category, meterPurposes } = this.props;
        // const x = meterPurposes && meterPurposes.toJS();
        if (recordToEdit && recordToEdit.purpose) {
            return recordToEdit.purpose;
        }
        if (meterPurposes && meterPurposes.length > 0) {
            for (const c in meterPurposes) {
                if (meterPurposes[c].category === category)
                    return meterPurposes[c].label
            }
            return meterPurposes[0].label;
        }
        return undefined;
    }
    
    getInitialFlavor = (recordToEdit) => {
        const { meterFlavors } = this.props;

        if (recordToEdit && recordToEdit.modbusFlavor) {
            return recordToEdit.modbusFlavor;            
        }
        
        if (meterFlavors && meterFlavors.length > 0) {
            return meterFlavors[0].label;
        }

        return undefined;
    }

    findHubMeters = (props) => {
        const {
            metersDataAreLoading,
            metersData,
        } = props;
        if (!metersDataAreLoading && metersData) {
            return metersData.filter(item => item.hub);
        }
        return [];
    }

    getInitialHub = (recordToEdit) => {
        if (!recordToEdit){
            const { hubMeterId } = this.props;
            return hubMeterId;
        }
        const hub = this.findHubMeters(this.props).find(item => item.id === recordToEdit.hubMeterId);
        if (!hub) {
            return undefined;
        }
        return hub.id;
    }

    hideMacAddress = () => {
        const { meterTypes, form } = this.props;
        const { getFieldValue } = form;

        const selectedMeterType = getFieldValue('type');

        if (selectedMeterType === undefined) {
            return false;
        }

        const selectedType = meterTypes.find(item => item.label === selectedMeterType);

        if (selectedType !== undefined && selectedType.evccTemplate !== null && selectedType.evccTemplate !== ''){
            return true;
        }

        return false;
    }

    showPassword = () => {
        const { meterTypes, form } = this.props;
        const { getFieldValue } = form;

        const selectedMeterType = getFieldValue('type');

        if (selectedMeterType === undefined) {
            return false;
        }

        const selectedType = meterTypes.find(item => item.label === selectedMeterType);

        if (selectedType !== undefined && selectedType.needsPassword !== null && selectedType.needsPassword){
            return true;
        }

        return false;
    }



    showField = (record, fieldId) => {
        const { meterTypes, form } = this.props;
        const { getFieldValue } = form;

        const selectedMeterType = getFieldValue('type');

        if (selectedMeterType === undefined) {
            return false;
        }

        const selectedType = meterTypes.find(item => item.label === selectedMeterType);

        const fieldVisibilityDefElement = this.fieldVisibilityDef[fieldId];
        if(fieldVisibilityDefElement === undefined){
            return false;
        }
        const includes = fieldVisibilityDefElement.list.includes(selectedType === undefined ? undefined : selectedType.label);
        if(fieldVisibilityDefElement.whiteList){
            return includes;
        }
        return !includes;
    }

    showPrices = (record) => {
        const { meterTypes, form } = this.props;
        const { getFieldValue } = form;

        const purpose = getFieldValue('purpose');

        if (purpose === undefined) {
            return false;
        }

        return purpose === 'Usage' || purpose === 'Grid' || purpose === 'Pv' || purpose === 'Battery';
    }

    isSolax = () => {
        const { meterTypes, form } = this.props;
        const { getFieldValue } = form;

        const selectedMeterType = getFieldValue('type');

        if (!selectedMeterType) {
            return false;
        }

        return selectedMeterType === 'Solax';
    }

    getFilteredMeterTypes = (record) => {
        const { meterTypes } = this.props;

        let filtered;

        if (record && record.type && record.type.toLowerCase() === 'loadprofile') {
            filtered = meterTypes.filter(type => type.label.toLowerCase() !== 'lechacal');
        }

        if (record && record.type && record.type.toLowerCase() === 'lechacal') {
            filtered = meterTypes.filter(type => type.label.toLowerCase() !== 'loadprofile');
        }

        filtered = meterTypes.filter(type => type.label.toLowerCase() !== 'loadprofile' && type.label.toLowerCase() !== 'lechacal');

        filtered.sort((a, b) => {
            if (a.label.toLowerCase() < b.label.toLowerCase()) {
              return -1;
            }
            if (a.label.toLowerCase() > b.label.toLowerCase()) {
              return 1;
            }
            return 0;
          });

        console.log("Sorted: ", JSON.stringify(filtered, null, 4));

        return filtered;
    }

    getIPAddressEnabled = () => {
        const { form } = this.props;
        const { getFieldValue } = form;

        const selectedMeterType = getFieldValue('type');

        console.log('selectedMeterType: ', JSON.stringify(selectedMeterType, null, 4));

        if (!selectedMeterType) {
            return true;
        }

        const recordType = selectedMeterType.toLowerCase();

        if (recordType === 'iwattmeter' ||
            recordType === 'iwattcontroller' ||
            recordType === 'iwattcontrollerv3' ||
            recordType === 'iothub' ||
            recordType === 'smartpi') {
            return false;
        }

        return true;
    }

    extractEnphase = () => {
        const { recordToEdit } = this.props;
        if (recordToEdit && recordToEdit.type && recordToEdit.type === 'EnphaseIqEnvoy' &&
            recordToEdit.thirdPartyAccessUi) {
            const result = JSON.parse(recordToEdit.thirdPartyAccessUi);
            return result;
        }
        return undefined;
    }

    render() {
        const {
            form,
            isShown,
            isLoading,
            msgs,
            onCancel,
            recordToEdit,
            meterTypesIsLoading,
            meterPurposes,
            meterPurposesIsLoading,
            meterFlavors,
            meterFlavorsIsLoading,
            metersData,
            metersDataAreLoading,
            isAdmin
        } = this.props;
        const { getFieldValue, getFieldDecorator } = form;
        const metersNotSelf = metersData !== undefined && metersData !== null ? metersData.filter(item => !recordToEdit || item.meter !== recordToEdit.meter) : [];
        const metersBattery = metersData !== undefined && metersData !== null ? metersData.filter(item => item.purpose === 'Battery') : [];

        return (
            <Modal
                key="admin-users-modal-add-or-edit"
                visible={isShown}
                confirmLoading={isLoading}
                width={MODAL_SIZES.MEDIUM}
                title={
                    !recordToEdit
                        ? msgs.homes.detail.addMeterModalTitle
                        : `${msgs.homes.detail.editMeterModalTitle} - ${
                              recordToEdit ? recordToEdit.name : ''
                          }`
                }
                onCancel={onCancel}
                onOk={this.handleSubmit}
                cancelText={msgs.cancel}
                okText={msgs.save}
            >
                <Spin spinning={isLoading} size="large">
                    <Form>
                        {getFieldValue('hasError') && (
                            <Row>
                                <Col xs={24}>
                                    <Alert
                                        message={getFieldValue('hasError')}
                                        type="error"
                                        showIcon
                                        closable
                                        onClose={this.handleAlertClose}
                                    />
                                </Col>
                            </Row>
                        )}

                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.detail.meterType}>
                                    {getFieldDecorator('type', {
                                        initialValue: recordToEdit && recordToEdit.type,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(
                                        <Select
                                            type="text"
                                            dropdownMatchSelectWidth={false}
                                            onChange={this.handleSelectMeterType}
                                            placeholder={
                                                meterTypesIsLoading ? msgs.loading : msgs.select // placeholder is not working :(
                                            }
                                            notFoundContent={
                                                !meterTypesIsLoading ? (
                                                    <span>
                                                        <Icon type="loading" />
                                                        {` ${msgs.loading}`}
                                                    </span>
                                                ) : (
                                                    <span>{msgs.noData}</span>
                                                )
                                            }
                                        >
                                            {this.getFilteredMeterTypes(recordToEdit).map(type => (
                                                <Select.Option value={type.label} key={type.label}>
                                                    {getDisplayLabelForMeterType(type.label)}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.detail.meterName}>
                                    {getFieldDecorator('name', {
                                        initialValue: recordToEdit ? recordToEdit.name : undefined,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(<Input type="text" maxLength={20}/>)}
                                </Form.Item>
                            </Col>
                        </Row>

                        {this.showPrices(recordToEdit)
                            ?
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.euroPerKwhBuy}>
                                    {getFieldDecorator('euroPerKwhBuy', {
                                        initialValue:recordToEdit ? parseFloat(recordToEdit.euroPerKwhBuy) : 0.36,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(<InputNumber type="number" style={{ width: '100%' }} />)}
                                </Form.Item>
                            </Col>
                        </Row>: undefined}
                        {this.showPrices(recordToEdit)
                            ?
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.euroPerKwhSell}>
                                    {getFieldDecorator('euroPerKwhSell', {
                                        initialValue:recordToEdit ? parseFloat(recordToEdit.euroPerKwhSell) : 0.1,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(<InputNumber type="number" style={{ width: '100%' }} />)}
                                </Form.Item>
                            </Col>
                        </Row>: undefined}
                            {this.showPrices(recordToEdit)
                                    ?
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.kgco2PerKwh}>
                                    {getFieldDecorator('kgco2PerKwh', {
                                        initialValue:recordToEdit ? parseFloat(recordToEdit.kgco2PerKwh) : 0.60,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(<InputNumber type="number" style={{ width: '100%' }} />)}
                                </Form.Item>
                            </Col>
                        </Row>: undefined}

                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.capacity}>
                                    {getFieldDecorator('capacity', {
                                        initialValue:recordToEdit ? parseFloat(recordToEdit.capacity) : null,
                                    })(<InputNumber type="number" style={{ width: '100%' }} />)}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.installationDate}>
                                    {getFieldDecorator('installationDate', {
                                        initialValue:recordToEdit ? moment(recordToEdit.installationDate) : moment(),
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(
                                        <DatePicker />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        {this.showField(recordToEdit, 'macAddress')
                        ?
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.detail.meterMacAddress}>
                                    {getFieldDecorator('macAddress', {
                                        initialValue: recordToEdit ? recordToEdit.macAddress : undefined,
                                        rules: [
                                            {
                                                pattern: /^[0-9a-fA-F]{12}$/,
                                                length: 12,
                                                message: msgs.homes.detail.meterMacAddressFormatField
                                            }
                                        ]
                                    })(<Input type="text" />)}
                                </Form.Item>
                            </Col>
                        </Row> : undefined
                        }
                        {this.showField(recordToEdit, 'ipAddress') ?
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.detail.meterIpAddress}>
                                    {getFieldDecorator('ipAddress', {
                                        initialValue: recordToEdit ? recordToEdit.ipAddress : undefined,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(<Input type="text" disabled={!this.getIPAddressEnabled()}/>)}
                                </Form.Item>
                            </Col>
                        </Row>
                            : undefined
                        }
                        {this.showField(recordToEdit, 'params') ?
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={this.isSolax ? msgs.homes.detail.solaxRegistrationNr : msgs.homes.detail.neoomBeaamApiKey}>
                                        {getFieldDecorator('params', {
                                            initialValue: recordToEdit ? recordToEdit.params : undefined,
                                            rules: [{ required: true, message: msgs.requiredField }]
                                        })(<Input type="text" />)}
                                    </Form.Item>
                                </Col>
                            </Row>
                            : undefined
                        }
                        {this.showField(recordToEdit, 'url') ?
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.meterUrl}>
                                        {getFieldDecorator('url', {
                                            initialValue: recordToEdit ? recordToEdit.url : undefined,
                                        })(<Input type="text" />)}
                                    </Form.Item>
                                </Col>
                            </Row>
                            : undefined
                        }
                        {this.showField(recordToEdit, 'enphaseUser') ?
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.enphaseUser}>
                                        {getFieldDecorator('enphaseUser', {
                                            initialValue: this.extractEnphase() ? this.extractEnphase().user : undefined,
                                        })(<Input type="text" />)}
                                    </Form.Item>
                                </Col>
                            </Row>
                            : undefined
                        }
                        {this.showField(recordToEdit, 'enphasePassword') ?
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.auth.passwordLabel}>
                                        {getFieldDecorator('enphasePassword', {
                                            initialValue: this.extractEnphase() ? this.extractEnphase().password : undefined,
                                        })(<Input type="password"/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                            : undefined
                        }
                        {this.showField(recordToEdit, 'enphaseSerial') ?
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.enphaseSerial}>
                                        {getFieldDecorator('enphaseSerial', {
                                            initialValue: this.extractEnphase() ? this.extractEnphase().envoy_serial : undefined,
                                        })(<Input type="text" />)}
                                    </Form.Item>
                                </Col>
                            </Row>
                            : undefined
                        }
                        {this.showPassword(recordToEdit) ?
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.auth.passwordLabel}>
                                        {getFieldDecorator('thirdPartyAccessUi', {
                                            initialValue: recordToEdit ? recordToEdit.thirdPartyAccessUi : undefined,
                                        })(<Input type="password"/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                            : undefined
                        }

                        {this.showField(recordToEdit, 'modbusId') && <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.detail.modbusId}>
                                    {getFieldDecorator('modbusId', {
                                        initialValue: recordToEdit ? recordToEdit.modbusId : 1,
                                    })(<InputNumber type="number" style={{ width: '100%' }} />)}
                                </Form.Item>
                            </Col>
                        </Row>}

                        {this.showField(recordToEdit, 'modbusFlavor') ?
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.flavor}>
                                        {getFieldDecorator('modbusFlavor', {
                                            initialValue: this.getInitialFlavor(recordToEdit)
                                        })(
                                            <Select
                                                type="text"
                                                dropdownMatchSelectWidth={false}
                                                placeholder={
                                                    meterFlavorsIsLoading ? msgs.loading : msgs.select // placeholder is not working :(
                                                }
                                                notFoundContent={
                                                    !meterFlavorsIsLoading ? (
                                                        <span>
                                                        <Icon type="loading"/>
                                                            {` ${msgs.loading}`}
                                                    </span>
                                                    ) : (
                                                        <span>{msgs.noData}</span>
                                                    )
                                                }
                                            >
                                                {meterFlavors ? meterFlavors.map(type => (
                                                    <Select.Option value={type.label} key={type.label}>
                                                        {type.label}
                                                    </Select.Option>
                                                )) : ''}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            : undefined
                        }
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.detail.purpose}>
                                    {getFieldDecorator('purpose', {
                                        initialValue: this.getInitialPurpose(recordToEdit),
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(
                                        <Select
                                            type="text"
                                            dropdownMatchSelectWidth={false}
                                            placeholder={
                                                meterPurposesIsLoading ? msgs.loading : msgs.select // placeholder is not working :(
                                            }
                                            notFoundContent={
                                                !meterPurposesIsLoading ? (
                                                    <span>
                                                        <Icon type="loading" />
                                                        {` ${msgs.loading}`}
                                                    </span>
                                                ) : (
                                                    <span>{msgs.noData}</span>
                                                )
                                            }
                                        >
                                            {meterPurposes ? meterPurposes.map(type => (
                                                <Select.Option value={type.label} key={type.label}>
                                                    {type.label}
                                                </Select.Option>
                                            )) : ''}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.detail.hub}>
                                    {getFieldDecorator('hubMeterId', {
                                        initialValue: this.getInitialHub(recordToEdit)
                                    })(
                                        <Select
                                            type="text"
                                            dropdownMatchSelectWidth={false}
                                            placeholder={
                                                metersDataAreLoading ? msgs.loading : msgs.select // placeholder is not working :(
                                            }
                                            notFoundContent={
                                                !metersDataAreLoading ? (
                                                    <span>
                                                        <Icon type="loading" />
                                                        {` ${msgs.loading}`}
                                                    </span>
                                                ) : (
                                                    <span>{msgs.noData}</span>
                                                )
                                            }
                                        >
                                            <Select.Option value={undefined} key="undefined">
                                                {msgs.homes.detail.noController}
                                            </Select.Option>
                                            {this.findHubMeters(this.props).map(meter => (
                                                <Select.Option value={meter.meter} key={meter.meter}>
                                                    {meter.name}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        {this.showField(recordToEdit, 'meterA') ?
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.meterA}>
                                        {getFieldDecorator('meterA', {
                                            initialValue: recordToEdit && recordToEdit.meterA
                                        })(
                                            <Select
                                                type="text"
                                                dropdownMatchSelectWidth={false}
                                                placeholder={
                                                    metersDataAreLoading ? msgs.loading : msgs.select
                                                }
                                                notFoundContent={
                                                    !metersDataAreLoading ? (
                                                        <span>
                                                        <Icon type="loading" />
                                                            {` ${msgs.loading}`}
                                                    </span>
                                                    ) : (
                                                        <span>{msgs.noData}</span>
                                                    )
                                                }
                                            >
                                                <Select.Option value={-1} key="-1">
                                                    {msgs.homes.detail.noController}
                                                </Select.Option>
                                                {metersNotSelf.map(meter => (
                                                    <Select.Option value={meter.meter} key={meter.meter}>
                                                        {meter.name}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row> : undefined}
                        {this.showField(recordToEdit, 'meterB') ?
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.meterB}>
                                        {getFieldDecorator('meterB', {
                                            initialValue: recordToEdit && recordToEdit.meterB
                                        })(
                                            <Select
                                                type="text"
                                                dropdownMatchSelectWidth={false}
                                                placeholder={
                                                    metersDataAreLoading ? msgs.loading : msgs.select
                                                }
                                                notFoundContent={
                                                    !metersDataAreLoading ? (
                                                        <span>
                                                        <Icon type="loading" />
                                                            {` ${msgs.loading}`}
                                                    </span>
                                                    ) : (
                                                        <span>{msgs.noData}</span>
                                                    )
                                                }
                                            >
                                                <Select.Option value={-1} key="-1">
                                                    {msgs.homes.detail.noController}
                                                </Select.Option>
                                                {metersNotSelf.map(meter => (
                                                    <Select.Option value={meter.meter} key={meter.meter}>
                                                        {meter.name}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row> : undefined}
                        {this.showField(recordToEdit, 'meterSoc') ?
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.meterSoc}>
                                        {getFieldDecorator('meterSoc', {
                                            initialValue: recordToEdit && recordToEdit.meterSoc
                                        })(
                                            <Select
                                                type="text"
                                                dropdownMatchSelectWidth={false}
                                                placeholder={
                                                    metersDataAreLoading ? msgs.loading : msgs.select
                                                }
                                                notFoundContent={
                                                    !metersDataAreLoading ? (
                                                        <span>
                                                        <Icon type="loading" />
                                                            {` ${msgs.loading}`}
                                                    </span>
                                                    ) : (
                                                        <span>{msgs.noData}</span>
                                                    )
                                                }
                                            >
                                                <Select.Option value={-1} key="-1">
                                                    {msgs.homes.detail.noController}
                                                </Select.Option>
                                                {metersBattery.map(meter => (
                                                    <Select.Option value={meter.meter} key={meter.meter}>
                                                        {meter.name}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            : undefined }
                        {
                            isAdmin &&
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.subscriptionType}>
                                        {getFieldDecorator('subscriptionType', {
                                            initialValue: recordToEdit && recordToEdit.subscriptionType,
                                            rules: [{ required: true, message: msgs.requiredField }]
                                        })(
                                            <Select
                                                type="text"
                                                dropdownMatchSelectWidth={false}
                                            >
                                                <Select.Option value="B" key="B">Basic</Select.Option>
                                                <Select.Option value="S" key="S">Standard</Select.Option>
                                                <Select.Option value="P" key="P">Premium</Select.Option>
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {
                            isAdmin &&
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.subscriptionUntil}>
                                        {getFieldDecorator('subscriptionUntil', {
                                            initialValue: recordToEdit && recordToEdit.subscriptionUntil ? moment(recordToEdit.subscriptionUntil).format('YYYY-MM-DD') :
                                                moment().add(1, 'y').format('YYYY-MM-DD'),
                                            rules: [{ required: true, message: msgs.requiredField, min:10 }]
                                        })(<Input style={{ width: '100%' }} maxLength={10} />)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {
                            isAdmin &&
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.partner}>
                                        {getFieldDecorator('partner', {
                                            initialValue: recordToEdit && recordToEdit.partner
                                        })(
                                            <Select
                                                type="text"
                                                dropdownMatchSelectWidth={false}
                                            >
                                                <Select.Option value="WATT" key="WATT">Watt Analytics</Select.Option>
                                                <Select.Option value="HUIZHI" key="HUIZHI">Huizhi Boyi China</Select.Option>
                                                <Select.Option value="" key="">-</Select.Option>
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }


                    </Form>
                </Spin>
            </Modal>
        );
    }

}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        isLoading: getAddOrEditMeterModalIsLoading(state),
        meterTypes: getMeterTypes(state),
        meterTypesIsLoading: getMeterTypesIsLoading(state),
        meterPurposes: getMeterPurposes(state),
        meterPurposesIsLoading: getMeterPurposesIsLoading(state),
        meterFlavors: getModbusFlavors(state),
        meterFlavorsIsLoading: getModbusFlavorsIsLoading(state),
        metersData: getHomeDetailMetersData(state),
        metersDataAreLoading: getHomeDetailMetersAreLoading(state),
        isAdmin: isRoleAdministrator(state)
    }),
    {
        fetchMeterPurposes,
        fetchMeterFlavors,
        onMeterPurposesList,
        onAddNewMeter,
        onEditMeter
    }
)(Form.create()(AddOrEditMeterModal));